import { render, staticRenderFns } from "./WZOverlay.vue?vue&type=template&id=00e8a00f&"
import script from "./WZOverlay.vue?vue&type=script&lang=js&"
export * from "./WZOverlay.vue?vue&type=script&lang=js&"
import style0 from "./WZOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports